module.exports = __webpack_public_path__ + "static/media/Bettkissen_60x40.6695e583.png";